/**
 * Traducción con MyMemory (gratis, sin API key): https://mymemory.translated.net/doc/spec.php
 *
 * Su cuota gratuita va por IP (~5.000 caracteres/día; ~50.000 con email). Desde Cloudflare
 * devuelve 429 porque las IPs de salida de Workers son compartidas, así que se llama
 * **desde el navegador**, con la IP y la cuota de cada usuario (admite CORS). El Worker
 * solo la usa como último recurso.
 */

import { normalizeSpanish, toAscii } from "./language";

export const MYMEMORY_URL = "https://api.mymemory.translated.net/get";

export class TranslationError extends Error {}

export async function translateEsEn(
  fetchFn: typeof fetch,
  url: string,
  text: string,
  email = "",
  timeoutMs = 15_000,
): Promise<string> {
  const params = new URLSearchParams({ q: normalizeSpanish(text), langpair: "es|en" });
  if (email) params.set("de", email);
  let data: { responseStatus?: number | string; responseDetails?: string; responseData?: { translatedText?: string } };
  try {
    const resp = await fetchFn(`${url}?${params}`, { signal: AbortSignal.timeout(timeoutMs) });
    if (!resp.ok) throw new Error(`HTTP ${resp.status} ${(await resp.text()).slice(0, 200)}`);
    data = await resp.json();
  } catch (e) {
    throw new TranslationError(`No se pudo traducir la pregunta: ${e}`);
  }
  const translated = data.responseData?.translatedText;
  if (String(data.responseStatus) !== "200" || !translated) {
    throw new TranslationError(`No se pudo traducir la pregunta: ${data.responseDetails}`);
  }
  return toAscii(translated);
}
